import { render, staticRenderFns } from "./myTip.vue?vue&type=template&id=c39a991c&scoped=true"
import script from "./myTip.vue?vue&type=script&lang=js"
export * from "./myTip.vue?vue&type=script&lang=js"
import style0 from "./myTip.vue?vue&type=style&index=0&id=c39a991c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39a991c",
  null
  
)

export default component.exports